export default __webpack_public_path__ + "static/media/avatar.4997cb8f.jpeg";